import { PFX } from './constants';
import {
  getIsHcsConsoleEnabled,
  getIsHcsConsoleEnabledVerbose,
  sentryLogging,
} from './utils';
export * from './features';

export { sentryLogging };
export const hcsConsole = {
  log: (message: string, attributes?: unknown) => {
    if (getIsHcsConsoleEnabled()) {
      console.log(PFX, message, attributes);
    }
  },
  logVerbose: (message: string, attributes?: unknown) => {
    if (getIsHcsConsoleEnabledVerbose()) {
      console.log(PFX, message, attributes);
    }
  },
  warn: (message: string, attributes?: unknown) => {
    if (getIsHcsConsoleEnabled()) {
      console.warn(PFX, message, attributes);
    }
  },
  error: (message: string, attributes?: unknown) => {
    if (getIsHcsConsoleEnabled()) {
      console.error(PFX, message, attributes);
    }
  },
};
